import React from 'react'

// Hooks
import { useContext } from 'react'

// Context
import { AuthContext } from '../../auth'
import { useTranslation } from 'react-i18next'

const Authenticate: React.FC = (props) => {

    const { t } = useTranslation()
    const auth = useContext(AuthContext)
    if(!auth.user) return null

    const handleLogoutClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        auth.actions.logout()
    }

    return <button onClick={handleLogoutClick}>{t('logout.logoutButton')}</button>

}

export default Authenticate